module.exports = __webpack_public_path__ + "static/media/alert_test_selected_hover.7dfdb43b.svg";